import { ExportButton } from '@/components/ExportButton/ExportButton';
import {
  ImportExportHistoryLink,
  ImportExportHistorySource,
  ImportExportHistoryType,
} from '@/components/ImportExportHistoryLink/ImportExportHistoryLink';
import { TExportBusinessDocument } from '@/context/services/business_document/BusinessDocument.service';
import { useTranslation } from '@/i18n';
import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './BusinessDocumentsTableActions.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  onOpenDrawer: () => void;
  onExport: (encoding: TExportBusinessDocument) => void;
  isDisabled: boolean;
};

export const BusinessDocumentsTableActions: FC<Props> = memo(
  ({ onOpenDrawer, onExport, isDisabled }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const state = useMemo(() => {
      return { from: location.pathname };
    }, [location.pathname]);

    return (
      <div className={cx(styles['table-actions-container'])}>
        <div className={cx(styles['table-actions-container-export'])}>
          <ImportExportHistoryLink
            source={ImportExportHistorySource.business_documents}
            type={ImportExportHistoryType.export}
            state={state}
          />
          <ExportButton isDisabled={isDisabled} onExport={onExport} />
        </div>
        <ButtonV2
          size='sm'
          onClick={() => onOpenDrawer()}
          testId='bulk-upload-bussiness-document'
        >
          {t('upload')}
        </ButtonV2>
      </div>
    );
  }
);
BusinessDocumentsTableActions.displayName = 'BusinessDocumentsTableActions';
